export const raDialogsStyle = {
  '& .MuiCardContent-root': {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 272px)',
  },
} as const;

export const booleanInputStyle = {
  '& .MuiFormControlLabel-root': { flexDirection: 'row-reverse', mx: 0 },
  '& .MuiFormControlLabel-label': { mr: 'auto' },
} as const;
